import { useState } from 'react';
import * as claudeService from '../services/claude.js';

export function useAI(addNotification) {
  const [aiOutput, setAiOutput] = useState('');
  const [aiLoading, setAiLoading] = useState(false);

  async function runAI(fn, successMsg) {
    setAiLoading(true);
    setAiOutput('');
    try {
      const result = await fn();
      const output = JSON.stringify(result, null, 2);
      setAiOutput(output);
      if (successMsg) addNotification(successMsg, 'success');
      return result;
    } catch (err) {
      console.error('AI error:', err);
      setAiOutput('Error: ' + err.message);
      addNotification('AI operation failed — ' + err.message, 'error');
    } finally {
      setAiLoading(false);
    }
  }

  const scoreLead = (contact) =>
    runAI(() => claudeService.scoreLead(contact), 'Lead scored successfully!');

  const draftEmail = (contact, purpose) =>
    runAI(() => claudeService.draftEmail(contact, purpose), 'Email drafted!');

  const analyzeCompany = (company) =>
    runAI(() => claudeService.analyzeCompany(company), 'Company analysis complete!');

  const generateCampaign = (audience) =>
    runAI(() => claudeService.generateCampaign(audience), 'Campaign generated!');

  return { aiOutput, aiLoading, scoreLead, draftEmail, analyzeCompany, generateCampaign };
}
